import * as React from "react";
export default class SingleClickLink extends React.Component<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>> {
    swallowClick: boolean = false;
    onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const { onClick } = this.props;
        if (onClick) {
            if (this.swallowClick) return;
            this.swallowClick = true;
            setTimeout(() => {
                this.swallowClick = false;
            }, 250);
            onClick(event);
        }
    }
    render() {
        const { onClick, children, ...props } = this.props;
        return <a onClick={this.onClick} {...props}>{children}</a>;
    }
}